// extracted by mini-css-extract-plugin
module.exports = {"box-default":"section-visual_box-default__JcD5D box_pad-vertical__Bef2c","visual":"section-visual_visual__MwBmr","fade":"section-visual_fade__Ih9sH"};